// extracted by mini-css-extract-plugin
export default {"SideBarMenus":"sideBar_SideBarMenus__yTUmW","nav":"sideBar_nav__E7yTp","navItem":"sideBar_navItem__uTJUA","navLink":"sideBar_navLink__I+QN-","active":"sideBar_active__QlPuh"};